import React, { useEffect, useRef } from 'react'
import ChartDisplay from './ChartDisplay'
import LoadingSpinner from '../../ui/LoadingSpinner'

const ChartVisualizationArea = React.forwardRef(({
  chartDataLoading,
  series,
  annotations,
  onXAxisRangeUpdate,
  show,
}, ref) => {
  const measuredHeightRef = useRef(null)

  useEffect(() => {
    // Capture height when data is loaded and the component is rendered with series
    if (!chartDataLoading && ref.current && series?.length > 0) {
      measuredHeightRef.current = ref.current.offsetHeight
    }
    // measuredHeightRef.current retains the last valid height to prevent layout shifts
  }, [chartDataLoading, series, ref])

  // Render the component if 'show' is true or if data is currently loading.
  // Hide if 'show' is false AND data is not loading.
  if (!show && !chartDataLoading) {
    return null
  }

  return (
    <div
      ref={ref}
      className="chart-visualization-area mb-4"
      style={{ height: (chartDataLoading && measuredHeightRef.current) ? `${measuredHeightRef.current}px` : 'auto' }}
    >
      <ChartDisplay
        series={series}
        annotations={annotations}
        onXAxisRangeUpdate={onXAxisRangeUpdate}
      />
      {chartDataLoading && (
        <div className="chart-loading-overlay">
          <LoadingSpinner message="Updating chart..." />
        </div>
      )}
    </div>
  )
})

ChartVisualizationArea.displayName = 'ChartVisualizationArea'

export default ChartVisualizationArea
